import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Apartments.css';    
import SlidingGallery from './SlidingGallery';

// Declare the hostawayCalendarWidget property on window
declare global {
  interface Window {
    hostawayCalendarWidget?: (config: any) => void;
  }
}

const Kinloch: React.FC = () => {
  const images = [
    { url: `${process.env.PUBLIC_URL}/images/Kinloch/kitchen_1.jpg`, alt: "Kinloch kitchen 1" },
    { url: `${process.env.PUBLIC_URL}/images/Kinloch/kitchen_2.jpg`, alt: "Kinloch kitchen 2" },
    { url: `${process.env.PUBLIC_URL}/images/Kinloch/living_room_1.jpg`, alt: "Kinloch living room 1" },
    { url: `${process.env.PUBLIC_URL}/images/Kinloch/washing_machine.jpg`, alt: "Kinloch washing machine" },
    { url: `${process.env.PUBLIC_URL}/images/Kinloch/bedroom_1.jpg`, alt: "Kinloch bedroom 1" },
    { url: `${process.env.PUBLIC_URL}/images/Kinloch/bathroom_1.jpg`, alt: "Kinloch bathroom 1" },
    { url: `${process.env.PUBLIC_URL}/images/Kinloch/bathroom_2.jpg`, alt: "Kinloch bathroom 2" },
    { url: `${process.env.PUBLIC_URL}/images/Kinloch/hall_1.jpg`, alt: "Kinloch hall 1" },
    { url: `${process.env.PUBLIC_URL}/images/Kinloch/hall_2.jpg`, alt: "Kinloch hall 2" },
    { url: `${process.env.PUBLIC_URL}/images/Kinloch/hall_3.jpg`, alt: "Kinloch hall 3" },
    { url: `${process.env.PUBLIC_URL}/images/Kinloch/hall_4.jpg`, alt: "Kinloch hall 4" },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    // Load the calendar script
    const script = document.createElement('script');
    script.src = 'https://d2q3n06xhbi0am.cloudfront.net/calendar.js';
    script.async = true;
    script.onload = () => {
      if (window.hostawayCalendarWidget) {
        window.hostawayCalendarWidget({
          baseUrl: 'https://119528_1.holidayfuture.com/',
          listingId: 419132,
          numberOfMonths: 2,
          openInNewTab: true,
          font: 'Open Sans',
          rounded: true,
          button: {
            action: 'checkout',
            text: 'Book now',
          },
          clearButtonText: 'Clear dates',
          color: {
            mainColor: '#666699',
            frameColor: '#000000',
            textColor: 'green',
          },
        });
      }
    };
    document.head.appendChild(script);
  }, []);

  return (
    <div className="location-container" style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
      <div className="location-content side-by-side-layout">
        <div className="image-section">
          <img 
            src={`${process.env.PUBLIC_URL}/images/Kinloch/living_room_1.jpg`} 
            alt="Kinloch living room"
            width="400" 
            height="500" 
          />
        </div>

        <div className="content-section">
          <h3>Kinloch Apartment</h3>
          <h3>Spacious Ground-Floor Two Bedroom Apartment with Wheelchair Access</h3>

          <p>
            Kinloch is a bright and generously sized <strong>two bedroom apartment</strong> located on the 
            <strong> ground floor</strong>, designed with comfort, accessibility, and flexibility in mind.
          </p>

          <p>
            The apartment accommodates up to <strong>five guests</strong> and is fully <strong>wheelchair accessible</strong>, 
            with <strong>easy, step-free access from the car park</strong>. The <strong>twin bedroom</strong> features its own 
            <strong> en-suite wetroom</strong>, ideal for guests who prefer or require walk-in shower facilities. 
            The <strong>master bedroom</strong> includes a <strong>double bed and a single bed</strong>, offering versatility 
            for families, friends, or mixed groups.
          </p>

          <p>
            Facing <strong>south</strong>, Kinloch enjoys plenty of natural light throughout the day, creating a warm 
            and welcoming atmosphere. The <strong>spacious kitchen/living area</strong> is perfect for dining, relaxing, 
            or planning your next adventure.
          </p>

          <p>
            Whether you're travelling as a group or looking for accessible accommodation without compromising on style, 
            Kinloch offers space, practicality, and peaceful surroundings — all on one easy level.
          </p>

          <div id="hostaway-calendar-widget"></div>
          <p><strong>Can't find availability for the dates you're looking for? Try our sister apartments <Link to="/cairn">Cairn</Link> or <Link to="/brora">Brora</Link> at the same location!</strong></p>

          <div className="slider-wrapper">
            <SlidingGallery 
              images={images} 
              currentSlide={currentSlide} 
              onSlideChange={setCurrentSlide} 
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Kinloch;
